$(document).ready(function () {

    $('#nav-search-field').on('blur', function () {
        $('#nav-search').hide('slow');
        $('#close-search').hide('slow');
        $('#show-search').show('slow');
    });

    window.navContainer = $(".navContainer");
    window.subscribeBar = $("#subscribe-bar");
    window.navBar = $(".navbar");


    $(window).scroll(function () {

        var scroll = $(window).scrollTop();
        var scrollBottom = $(document).height() - $(window).height() - $(window).scrollTop();

        //>=, not <=
        if (scroll >= 150) {

            if (!window.navContainer.hasClass("navContainerScroll")) {
                window.navContainer.hide();
                window.navContainer.addClass("navContainerScroll");

                window.navContainer.show();
            }


        } else {
            if (window.navContainer.hasClass("navContainerScroll")) {
                window.navContainer.removeClass("navContainerScroll");
            }

        }

        if (scroll >= 500 && scrollBottom >=500) {

            if (window.subscribeBar.hasClass("hidden")) {
                window.subscribeBar.removeClass("hidden");
            }


        } else {
            if (!window.subscribeBar.hasClass("hidden")) {
                window.subscribeBar.addClass("hidden");
            }

        }

    }); //missing );

    /*
     $('ul.nav li.dropdown').hover(function() {
     $(this).find('.dropdown-menu').stop(true, true).delay(200).slideDown(300);
     }, function() {
     $(this).find('.dropdown-menu').stop(true, true).delay(200).slideUp(300);
     });
     */

});



// WEBPACK FOOTER //
// ./js/nav.js